import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class EducationDetails extends Component {

    constructor(props){
      super(props);
      this.state = {
        isLoading: false,
        successMsg: "",
        errorMsg: "",
        undergradUI: this.getPropertyValue("undergrad"),
        undergradCollegeUI: this.getPropertyValue("undergradCollege"),
        undergradUnivUI: this.getPropertyValue("undergradUniv"),
        undergradCityUI: this.getPropertyValue("undergradCity"),
        undergradStateUI: this.getPropertyValue("undergradState"),

        fellowshipUI: this.getPropertyValue("fellowship"),
        fellowshipSpecialityUI: this.getPropertyValue("fellowshipSpeciality"),
        fellowshipCollegeUI: this.getPropertyValue("fellowshipCollege"),
        fellowshipUnivUI: this.getPropertyValue("fellowshipUniv"),
        fellowshipCityUI: this.getPropertyValue("fellowshipCity"),
        fellowshipStateUI: this.getPropertyValue("fellowshipState"),
      }

    }

    getPropertyValue(propertyName){
       if(this.props.userProfile[propertyName] && this.props.userProfile[propertyName].length > 0){
         return this.props.userProfile[propertyName];
       }
       return "";
    }

    submitForm = async event => {
      event.preventDefault();
      this.setState({ isLoading: true});

      try{
        await this.props.updateUserProfile(this.state);
        this.setState({isLoading: false, successMsg: "Successfully updated your interests."});
      }catch(e){
        this.setState({isLoading: false, errorMsg: e.message});
      }
    }

    validateForm(){
      return true;
    }

    handleChange = event => {
      event.preventDefault();

      if(event.target.value.length > 0){
        this.setState({
          [event.target.id]: event.target.value
        });
      }

      this.setState({
        [event.target.id+"UI"]: event.target.value,
        successMsg: "",
        errorMsg: ""
      });
    }

    getSuccessNotification(successMsg){
      return this.state.successMsg && this.state.successMsg.length > 0
                              ? <div className="alert alert-success" role="alert">
                                  {this.state.successMsg}
                                </div>
                              : "";
    }

    getErrorElement(){
       return this.state.errorMsg && this.state.errorMsg.length > 0
                               ? <div className="alert alert-danger" role="alert">
                                   {this.state.errorMsg}
                                 </div>
                               : "";
    }

    render(){
      return(
        <div className="container">
              <br />
              <div className="row cols-xs-space cols-sm-space cols-md-space">
                    <div className="col-lg-12">
                      <div className="row">
                           <div className="col-lg-2"></div>
                           <div className="col-lg-8 profile-udpate-widget">
                             <div class="card">
                                 <div class="card-title b-xs-bottom">
                                     <h3 class="heading heading-sm text-uppercase">Educational Details</h3>

                                 </div>
                                 <div class="card-body">
                                     <h4>Post Graduation Details</h4>
                                     <form id="educationDetailsForm" onSubmit={this.submitForm}>
                                          <div className="row">
                                             <div className="col-md-6">
                                                 <div className="form-group">
                                                     <label for="undergrad">Specialization</label>
                                                     <input type="text" id="undergrad"
                                                          className="form-control"
                                                          value={this.state.undergradUI}
                                                          placeholder=""
                                                          onChange={this.handleChange} />
                                                 </div>
                                             </div>
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="undergradCollege">College</label>
                                                       <input type="text" id="undergradCollege"
                                                            className="form-control"
                                                            value={this.state.undergradCollegeUI}
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>

                                             </div>
                                         </div>

                                         <div className="row">
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="undergradUniv">University </label>
                                                       <input type="text" id="undergradUniv"
                                                            value={this.state.undergradUnivUI}
                                                            className="form-control"
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>
                                             </div>
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="undergradCity">City</label>
                                                       <input type="text" id="undergradCity"
                                                            value={this.state.undergradCityUI}
                                                            className="form-control"
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>
                                             </div>
                                         </div>


                                         <div className="row">
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="undergradState">State</label>
                                                       <input type="text" id="undergradState"
                                                            value={this.state.undergradStateUI}
                                                            className="form-control"
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>
                                             </div>

                                         </div>

                                         <br />

                                         <h4>Fellowship Details</h4>

                                         <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label for="fellowship">Fellowship</label>
                                                    <input type="text" id="fellowship"
                                                         className="form-control"
                                                         placeholder=""
                                                         value={this.state.fellowshipUI}
                                                         onChange={this.handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                  <div className="form-group">
                                                      <label for="fellowshipSpeciality">Speciality</label>
                                                      <select className="form-control"
                                                              id="fellowshipSpeciality"
                                                              value={this.state.fellowshipSpecialityUI}
                                                              onChange={this.handleChange}>
                                                          <option value="surgicalretina">Surgical Retina</option>
                                                          <option value="medicalretina">Medical Retina</option>
                                                          <option value="uvea">Uvea</option>
                                                          <option value="ocularoncology">Ocular Oncology</option>
                                                          <option value="neuroopthalmology">Neuro Opthalmology</option>
                                                      </select>
                                                  </div>

                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                  <div className="form-group">
                                                      <label for="fellowshipCollege">College </label>
                                                      <input type="text" id="fellowshipCollege"
                                                           className="form-control"
                                                           placeholder=""
                                                           value={this.state.fellowshipCollegeUI}
                                                           onChange={this.handleChange} />
                                                  </div>
                                            </div>
                                            <div className="col-md-6">
                                                  <div className="form-group">
                                                      <label for="fellowshipUniv">University</label>
                                                      <input type="text" id="fellowshipUniv"
                                                           className="form-control"
                                                           placeholder=""
                                                           value={this.state.fellowshipUnivUI}
                                                           onChange={this.handleChange} />
                                                  </div>
                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-md-6">
                                                  <div className="form-group">
                                                      <label for="fellowshipCity">City</label>
                                                      <input type="text" id="fellowshipCity"
                                                           className="form-control"
                                                           value={this.state.fellowshipCityUI}
                                                           placeholder=""
                                                           onChange={this.handleChange} />
                                                  </div>
                                            </div>
                                            <div className="col-md-6">
                                                  <div className="form-group">
                                                      <label for="fellowshipState">State</label>
                                                      <input type="text" id="fellowshipState"
                                                           value={this.state.fellowshipStateUI}
                                                           className="form-control"
                                                           placeholder=""
                                                           onChange={this.handleChange} />
                                                  </div>
                                            </div>

                                        </div>
                                         <br/>

                                         <div className="form-group align-center">

                                             <LoaderButton block bsStyle="primary" bsSize="large"
                                                   disable={!this.validateForm()} type="submit"
                                                   isLoading={this.state.isLoading} text=" Update "
                                                   loadingText="Updating Details..."
                                                   className="btn btn-primary"/>
                                         </div>
                                     </form>
                                     {this.getErrorElement()}
                                     {this.getSuccessNotification()}
                                 </div>
                             </div>
                           </div>

                           <div className="col-lg-2"></div>
                      </div>
                   </div>
              </div>
        </div>


      );
    }

}



// WEBPACK FOOTER //
// ./src/containers/EducationDetails.js